import React, { useContext } from 'react';
import PatientOtherUserPanel from './patient_other_user_panel';
import Context from '../../../../utils/context';

export default function ConversationOtherUserProfile({ otherUser, conversation, onCallCreated }) {
  const context = useContext(Context);
  const isMobile = context.viewport.getIsMobile();

  return (
    <PatientOtherUserPanel
      otherUser={otherUser}
      isMobile={isMobile}
      conversation={conversation}
      onCallCreated={onCallCreated}
    />
  );
}
